import { resolvePath } from './lib/path';

export const v1ApiPath = (...tokens: string[]) => resolvePath('v1', ...tokens);
